var _line, _line2, _path, _line3, _line4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWgWirWellSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 3,
    x2: 9.5,
    y2: 21,
    stroke: "#264C62",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 3,
    x2: 6.5,
    y2: 17,
    stroke: "#264C62",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3L3.75 8.5",
    stroke: "#264C62",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 18,
    y2: -0.75,
    transform: "matrix(0 1 1 0 15.25 3)",
    stroke: "#264C62",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 14,
    y2: -0.75,
    transform: "matrix(0 1 1 0 18.25 3)",
    stroke: "#264C62",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3L20.25 8.5",
    stroke: "#264C62",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgWirWellSelect);
export default __webpack_public_path__ + "static/media/wg-wir-well-select.dbe8cd0a6d08b57736f75d13a3db84c0.svg";
export { ForwardRef as ReactComponent };